/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Backstage_Queue_CreditInputs */

const en_scene_backstage_queue_credit = /** @type {(inputs: Scene_Backstage_Queue_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders on credit hold`)
};

/**
* | output |
* | --- |
* | "Orders on credit hold" |
*
* @param {Scene_Backstage_Queue_CreditInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_backstage_queue_credit = /** @type {((inputs?: Scene_Backstage_Queue_CreditInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Backstage_Queue_CreditInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_backstage_queue_credit(inputs)
});